import {validateColorAndPerformCastingIfNecessary} from '../../../privates/validations/styleValidation';
import styleService from './styleService';
import * as members from '../../../privates/privateMembers';
import StyleProperties from '../../../privates/styleConstants';

class BackgroundColorMixin {

  /**
   * @member backgroundColor
   * @memberof $w.Style
   * @param {external:String} backgroundColor
   */
    set backgroundColor(backgroundColor) {
         const compName = members._compName.get(this);
         const opacitySupport = true;

        const validColor = validateColorAndPerformCastingIfNecessary(backgroundColor, opacitySupport, StyleProperties.BACKGROUND_COLOR, compName);
        if (!validColor){
            return;
        }
        styleService.setStyle.call(this, StyleProperties.BACKGROUND_COLOR, validColor);
    }

    /**
     * @member backgroundColor
     * @label property
     * @syntax
     * get backgroundColor(): string
     * set backgroundColor(rgbaColor: string): void
     * @summary Sets or gets the background color of an element.
     * @description
     *  The background color value is a string representing an rgba color in one
     *  of the following formats:
     *
     *  + `"red"`: One of [140 predefined color names](https://www.w3schools.com/colors/colors_names.asp).
     *  + `"#FF0000"`: A hexadecimal rgb color value.
     *  + `"rgb(255,0,0)"`: An rgb() function color value.
     *  + `"#FF000000"`: A hexadecimal rgba color value.
     *  + `"rgba(255,0,0,1.0)"`: An rgba() function color value.
     *
     * This style can be used with the following elements:
     *
     *  + [`Box`]($w.Box.html)
     *  + [`Button`]($w.Button.html)
     *  + [`Checkbox`]($w.Checkbox.html)
     *  + [`CheckboxGroup`]($w.CheckboxGroup.html)
     *  + [`Dropdown`]($w.Dropdown.html)
     *  + [`Footer`]($w.Footer.html)
     *  + [`Form`]($w.Form.html)
     *  + [`Header`]($w.Header.html)
     *  + [`ProgressBar`]($w.ProgressBar.html)
     *  + [`RadioButtonGroup`]($w.RadioButtonGroup.html)
     *  + [`SignatureInput`]($w.SignatureInput.html)
     *  + [`TextBox`]($w.TextBox.html)
     *  + [`TextInput`]($w.TextInput.html)
     *  + [`UploadButton`]($w.UploadButton.html)
     *
     * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
     * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
     * @type {external:String}
     * @memberof $w.Style
     * @instance
     */
    get backgroundColor() {
       return styleService.getStyleParamValue.call(this, StyleProperties.BACKGROUND_COLOR);
    }

}

export default BackgroundColorMixin;
